import { AdminDetalleModal } from './AdminDetalleModal';
import { DetalleCampanaPage } from '../../pages/DetalleCampanaPage';

interface AdminDetalleCampanaModalProps {
  readonly isOpen: boolean;
  readonly campanaId: string;
  readonly lumisialNombre: string;
  readonly lumisialCiudad: string;
  readonly diocesisNombre: string;
  readonly provinciaNombre: string;
  readonly onClose: () => void;
}

export function AdminDetalleCampanaModal({
  isOpen,
  campanaId,
  lumisialNombre,
  lumisialCiudad,
  diocesisNombre,
  provinciaNombre,
  onClose,
}: AdminDetalleCampanaModalProps) {
  return (
    <AdminDetalleModal
      isOpen={isOpen}
      lumisialNombre={lumisialNombre}
      lumisialCiudad={lumisialCiudad}
      diocesisNombre={diocesisNombre}
      provinciaNombre={provinciaNombre}
      onClose={onClose}
    >
      <DetalleCampanaPage
        campañaId={campanaId}
        readOnly={true}
        onBack={onClose}
      />
    </AdminDetalleModal>
  );
}
